import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import LinkButton from 'flarum/common/components/LinkButton';
export default function addNavItem() {
  extend(IndexSidebar.prototype, 'navItems', items => {
    if (!app.forum.attribute('globalPollsEnabled')) {
      return;
    }
    items.add('fof-polls-showcase', LinkButton.component({
      href: app.route('fof.polls.showcase'),
      icon: 'fas fa-poll'
    }, app.translator.trans('fof-polls.forum.page.nav')), 35);
    const canStartGlobalPolls = app.forum.attribute('canStartGlobalPolls');
    if (canStartGlobalPolls) {
      items.add('fof-polls-list', LinkButton.component({
        href: app.route('fof.polls.list'),
        icon: 'fas fa-list'
      }, app.translator.trans('fof-polls.forum.page.nav-all')), 32);
      const canViewPollGroups = app.forum.attribute('canViewPollGroups');
      if (canViewPollGroups) {
        items.add('fof-poll-groups-list', LinkButton.component({
          href: app.route('fof.polls.groups.list'),
          icon: 'fas fa-layer-group'
        }, app.translator.trans('fof-polls.forum.page.nav-groups')), 30);
      }
    }
  });
}